import Req from "./request";
import Config, { GetEnv } from "../utils/config";

export function userLogin(code) {
	return Req({
		baseURL: Config.OAuthAPI[GetEnv()],
		method: "post",
		headers: {"remote_user":"1"}, //登录没有用户信息，随便传一个
		data: {
			Action: "WXLogin",
			Code: code
		}
	});
}
